'use client';

import { Button, Container, Typography } from '@mui/material';
import Link from 'next/link';

type PageErrorFallbackProps = {
  error: Error;
  reset?: () => void;
};

/**
 * This fallback is intended to display error information within a wrapped Page
 * (inside the layout)
 */
export function PageErrorFallback({ error, reset }: PageErrorFallbackProps) {
  return (
    <Container maxWidth="lg" sx={{ paddingTop: 4 }}>
      <Typography variant="h3" component="h1">
        Oops, something went wrong
      </Typography>

      {error.message && (
        <Typography variant="body1" color="primary.main">
          {error.message}
        </Typography>
      )}

      <Typography
        variant="body1"
        sx={{
          textAlign: 'center',
        }}
      >
        Please try refreshing the page or going back to the{' '}
        <Button href="/" component={Link}>
          homepage
        </Button>
        .
      </Typography>
      {reset && (
        <Button variant="contained" onClick={reset}>
          Reload
        </Button>
      )}
    </Container>
  );
}
